import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { LoginService } from './login.service';
import Swal from 'sweetalert2';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(
        private loginService: LoginService,
        private router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot) {
        if (this.loginService.IsloggedIn()) {
            if (route.data && route.data.requiresVerifiedAccount && !this.hasVerifiedAccount()) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Account verification required',
                    text: 'Your account is not verified. Please verify your account before proceeding to checkout.',
                    confirmButtonText: 'Go for Verification',
                    allowOutsideClick: false
                }).then(() => {
                    this.router.navigateByUrl('/my-account');
                });
                return false;
            }
            return true;
        } else {
            // Session is missing, corrupted or expired; ensure any stale token is
            // cleared before sending the user to the login page.
            this.loginService.userSessionOut();
            this.router.navigateByUrl('sign-in');
            return false;
        } 
    }

    private hasVerifiedAccount(): boolean {
        let user = this.loginService.user;

        if (!user) {
            try {
                user = JSON.parse(localStorage.getItem('user'));
            } catch (e) {
                user = null;
            }
        }

        return !!user && user.isVerified === true;
    }
}
